<script lang="ts">
  import { ImageData } from '../model/WorkflowExecutionImagesAndFeedback';
  import { LoadingState } from '../model/LoadingState';
  import {selected} from "../domain/store";

</script>

<div class="image-row">
  <div class="image-col">
    {#if $selected.resultImageState.loading}
      <div>loading image ...</div>
    {:else if $selected.resultImageState.error}
      <div>error loading image!</div>
    {:else if !!$selected.resultImageState.data}
      <img alt="peter"
        class="image-card"
        src={URL.createObjectURL($selected.resultImageState.data)}
      />
    {/if}
  </div>
</div>

<style>
  .image-row {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    padding: 10px;
  }
  .image-col {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .image-card {
    border-radius: 15px;
  }
</style>
